import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { RouteMapModalComponent } from '../route-map-modal/route-map-modal.component';

@Component({
  selector: 'app-form-popup',
  templateUrl: './form-popup.component.html',
  styleUrls: ['./form-popup.component.scss'],
})
export class FormPopupComponent {
  popupForm!: FormGroup;
  list: any;
  legOptions = [
    'Leg1',
    'Leg2',
    'Leg3',
    'Leg4',
    'Leg5',
    'Leg6',
    'Leg7',
    'Leg8',
    'Leg9',
    'Leg10',
  ];
  typeOptions = [
    'cosp',
    'noon',
    'eosp',
    'exclude',
    'drift',
    'Exclusion (Poor Visibility)',
    'Exclusion (Congested Waters)',
    'Exclusion ( Main Engine Issue)',
    'Exclusion (Armed Guards)',
    'Exclusion ( Bunkering)',
    'Exclusion ( Crew Change)',
    'Exclusion ( Taking Stores)',
    'Exclusion ( Deviation For Safety At Sea)',
    'Exclusion (CVR weather)',
    '',
  ];
  fileContent: string | ArrayBuffer | null = null;
  uploadedFile: File | null = null;
  selectedFiles: File[] = [];
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  nextStep: boolean = false;
  uploadedFileName: any;
  isAutoCompleteOn: boolean = false;
  isLoadingConfig: boolean = false;
  isLoadingMap: boolean = false;
  routesData: any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public payload: any,
    public dialogRef: MatDialogRef<FormPopupComponent>,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private dialog: MatDialog
  ) {
    this.popupForm = this.fb.group({});
    if (this.list) {
      this.list.forEach((_: any, i: any) => {
        this.popupForm.addControl('leg' + i, this.fb.control('Leg1'));
        this.popupForm.addControl('type' + i, this.fb.control('Type1'));
        this.popupForm.addControl('reason' + i, this.fb.control('Reason1'));
      });
    }
  }

  ngOnInit(): void {
    const base64File = sessionStorage.getItem('uploadedFile');
    const fileType = localStorage.getItem('fileType');
    if (this.payload) {
      this.uploadedFileName = this.payload.file.name;
      this.uploadedFile = this.payload.file;
    }
    if (fileType === 'json') {
      this.jsonData();
    }
  }
  jsonData() {
    this.nextStep = true;
    this.isLoadingConfig = true;
    let payload = {
      imo_number: this.payload.imo_number,
      start_date: this.payload.start_date,
      end_date: this.payload.end_date,
    };

    this.requestFormService.uploadFiles(payload).subscribe({
      next: (data) => {
        this.isLoadingConfig = false;
        console.log(data);
        this.list = Object.entries(data)
          .sort((a, b) => {
            const dayA = parseInt(a[0].replace('Day', ''), 10);
            const dayB = parseInt(b[0].replace('Day', ''), 10);
            return dayA - dayB;
          })
          .map(([key, value]) => ({
            key,
            value,
          }))
          .filter(item => {
            // Remove items with NaN timestamp or report_type that crash the UI
            const val = item.value as any;
            return val.timestamp && val.timestamp !== 'NaN' && !Number.isNaN(val.timestamp);
          });

        this.list.forEach((item: any, i: number) => {
          const cleanLeg = String(item.value.leg || '')
            .replace(/^\s*\d+\s*:\s*/, '')
            .trim();
          const cleanType = String(item.value.report_type || '')
            .replace(/^\s*\d+\s*:\s*/, '')
            .trim();
          const cleanReason = String(item.value.reason || '')
            .replace(/^\s*\d+\s*:\s*/, '')
            .trim();

          this.popupForm.addControl('leg' + i, this.fb.control(cleanLeg));
          this.popupForm.addControl('type' + i, this.fb.control(cleanType));
          this.popupForm.addControl('reason' + i, this.fb.control(cleanReason));
        });
      },
      error: (error) => {
        this.isLoadingConfig = false;
        console.error('API Error:', error);
      },
    });
  }
  // ✅ UPDATED FUNCTION: Cleaned selection logic
  onSelectionChange(index: number, controlName: string, event: any) {
    let selectedValue = event?.value ?? event?.target?.value ?? event;

    // 🧹 Remove unwanted prefix like "1: Leg2"
    if (typeof selectedValue === 'string') {
      selectedValue = selectedValue.replace(/^\s*\d+\s*:\s*/, '').trim();
    }

    // Update current control
    this.popupForm.controls[controlName].setValue(selectedValue);

    // Auto-complete logic for subsequent rows
    if (this.isAutoCompleteOn) {
      if (controlName.startsWith('leg')) {
        for (let i = index + 1; i < this.list.length; i++) {
          this.popupForm.controls['leg' + i].setValue(selectedValue);
        }
      } else if (controlName.startsWith('type')) {
        for (let i = index + 1; i < this.list.length; i++) {
          this.popupForm.controls['type' + i].setValue(selectedValue);
        }
      } else if (controlName.startsWith('reason')) {
        for (let i = index + 1; i < this.list.length; i++) {
          this.popupForm.controls['reason' + i].setValue(selectedValue);
        }
      }
    }
  }

  onFileSelected(event: any) {
    if (event.target.files) {
      this.selectedFiles = Array.from(event.target.files);
    }
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) throw new Error('Invalid base64 string format');

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }

  closeModal() {
    this.dialogRef.close();
    localStorage.removeItem('uploadedFile');
    localStorage.removeItem('uploadedFileName');
  }

  onSubmit(confirmed: boolean) {
    if (confirmed) {
      const data: {
        [key: string]: { Leg: string; report_type: string; reason: string };
      } = {};

      this.list?.forEach((item: any, index: number) => {
        const dayKey = `day${index + 1}`;
        const legValue = this.popupForm.controls['leg' + index].value || '';
        let typeValue = this.popupForm.controls['type' + index].value || '';
        const reasonValue =
          this.popupForm.controls['reason' + index].value || '';

        // ✅ For the first day keep report_type as is (no prefix)
        if (index === 0) {
          typeValue = typeValue;
        } else {
          // ✅ For all other days, prefix "1: " only if not already added
          if (!typeValue.startsWith('1:')) {
            typeValue = `1: ${typeValue}`;
          }
        }

        data[dayKey] = {
          Leg: legValue,
          report_type: typeValue,
          reason: reasonValue,
        };
      });

      const filesToUpload = [...this.selectedFiles];
      if (this.uploadedFile) {
        filesToUpload.push(this.uploadedFile);
      }

      const finalData = {
        formData: data,
        files: filesToUpload,
      };

      console.log('✅ Final JSON Output:', JSON.stringify(finalData.formData));
      this.dialogRef.close(finalData);
    } else {
      this.dialogRef.close();
    }
  }

  uploadfile() {
    if (this.fileInput)
      (this.fileInput.nativeElement as HTMLInputElement).click();
  }

  //  UPDATED FUNCTION: Clean list initialization
  proceedClick() {
    this.nextStep = true;
    this.isLoadingConfig = true;
    const filesToUpload: File[] = [...this.selectedFiles];
    if (this.uploadedFile) {
      filesToUpload.push(this.uploadedFile);
    }

    this.requestFormService.uploadFiles({ files: filesToUpload }).subscribe({
      next: (data) => {
        this.isLoadingConfig = false;
        console.log(data);
        this.list = Object.entries(data)
          .sort((a, b) => {
            const dayA = parseInt(a[0].replace('Day', ''), 10);
            const dayB = parseInt(b[0].replace('Day', ''), 10);
            return dayA - dayB;
          })
          .map(([key, value]) => ({
            key,
            value,
          }))
          .filter(item => {
            // Remove items with NaN timestamp or report_type that crash the UI
            const val = item.value as any;
            return val.timestamp && val.timestamp !== 'NaN' && !Number.isNaN(val.timestamp);
          });

        this.list.forEach((item: any, i: number) => {
          const cleanLeg = String(item.value.leg || '')
            .replace(/^\s*\d+\s*:\s*/, '')
            .trim();
          const cleanType = String(item.value.report_type || '')
            .replace(/^\s*\d+\s*:\s*/, '')
            .trim();
          const cleanReason = String(item.value.reason || '')
            .replace(/^\s*\d+\s*:\s*/, '')
            .trim();

          this.popupForm.addControl('leg' + i, this.fb.control(cleanLeg));
          this.popupForm.addControl('type' + i, this.fb.control(cleanType));
          this.popupForm.addControl('reason' + i, this.fb.control(cleanReason));
        });
        
        if (data.routes) {
          this.routesData = data.routes;
        }
      },
      error: (error) => {
        this.isLoadingConfig = false;
        console.error('API Error:', error);
      },
    });

    this.isLoadingMap = true;
    this.requestFormService.getRoutePreview({ 
      files: filesToUpload, 
      report_type: 'voyage',
      imo_no: this.payload?.imo_number,
      start_date: this.payload?.start_date,
      end_date: this.payload?.end_date
    }).subscribe({
      next: (res) => {
        this.isLoadingMap = false;
        if (res && res.routes) {
          this.routesData = res.routes;
        }
      },
      error: (err) => {
        this.isLoadingMap = false;
        console.error('Route preview failed', err);
      }
    });
  }

  deleteFile(file: File) {
    if (file === this.uploadedFile) {
      this.uploadedFile = null;
      this.uploadedFileName = null;
    } else {
      const index = this.selectedFiles.indexOf(file);
      if (index >= 0) {
        this.selectedFiles.splice(index, 1);
      }
    }
  }

  openMapModal() {
    if (!this.routesData) return;
    this.dialog.open(RouteMapModalComponent, {
      width: '80%',
      height: '80%',
      data: { routes: this.routesData }
    });
  }

  toggleMapView() {}

  parseTimestamp(timestamp: string): Date {
    return new Date(timestamp);
  }
}
